/**
 * Declerations
 */
// Plugins
import moment from "moment";

// Helpers
import Helper from "@/helpers/helper";

// mixins
import { ordermixins } from "@/mixins/ordermixins";
import { orderboxmixins } from "@/mixins/orderboxmixins";
import { mapMixins } from "@/mixins/mapMixins";


export const adminorderhistorymixins = {
    mixins: [ordermixins, orderboxmixins, mapMixins],
    props: {
        groupedhistory: {
            type: Array,
            default: () => [],
        },
        amendingorder: {
            type: Object,
            default: () => null,
        },
        changestatus: {
            type: Boolean,
            default: () => true,
        },
    },
    data() {
        return {
            expandtable: null,
        };
    },
    filters: {
        /**
         * Format date by
         * @param format
         */
        formatdate(date, format) {
            return date ? Helper.formatdate(date, format) : "";
        },
        /**
         * Force format date by
         * @param format
         */
        forceformatdate(date, format) {
            return date ? Helper.formatdate(date, format, true) : "";
        },
        /**
         * Format date by relation like
         * Today, Tomorrow, and MM/DD/YYYY
         */
        formatreldate(date) {
            return Helper.datestring(date);
        },
    },
    methods: {
        /**
         * Get accepted date
         */
        accepteddate(order) {
            const status = order.orderstatuses.find(
                (s) => s.status == "accepted"
            );
            return status ? status.created_at : "";
        },
        /**
         * Get delivered date
         */
        delivereddate(order) {
            const status = order.orderstatuses.find(
                (s) => s.status == "delivered"
            );

            return status ? status.created_at : "";
        },
        /**
         * Group order boxes and flavors
         */
        grouporderbox(orders) {
            const orderlist = Object.values(orders);

            const group = this.groupboxorder(orderlist);

            return group;
        },

        /**
         * Get amend statuses
         *
         */
        amendstatuses(order) {
            let amendlist = order.orderstatuses.filter((s) =>
                s.status.match(/amend/i)
            );

            return amendlist
                .slice()
                .sort(
                    (a, b) => new Date(a.updated_at) - new Date(b.updated_at)
                );
        },
        /**
         * Get delivery proof
         */
        getdeliverimg(order) {
            if (order.status == "delivered" || order.status == "confirm") {
                const status = order.orderstatuses.find(
                    (s) => s.status == "delivered"
                );

                return status ? status.status_image : "";
            } else {
                return "";
            }
        },
        /**
         * Check if ammend update status will be available after 24 hours after last delivery
         *
         */
        checkammendstatus(order) {
            this.$emit("update:amendingorder", order);
            setTimeout(() => {
                const deliverydate = this.amendingorder.orderstatuses.find(
                    (s) => s.status == "delivered"
                );

                if (deliverydate) {
                    const status = this.pastduration(
                        deliverydate.created_at,
                        12
                    );

                    this.$emit("update:changestatus", status);
                }
            }, 300);
        },
        /**
         * Check if delivered today
         * then show amend button only when it delivered today
         */
        checkiftoday(order) {
            const deliverydate = this.delivereddate(order);

            return deliverydate
                ? moment(deliverydate).isSame(moment(), "day")
                : false;
        },
        /**
         * Group same flavors
         */
        groupflavors(flavors) {
            return flavors.filter(
                (value, index, self) =>
                    index ==
                    self.findIndex((t) => t.flavor_id == value.flavor_id)
            );
        },
    },
}